import { render } from "./practice-people-authorised-trust-contact.html?vue&type=template&id=5eee72a4&scoped=true&ts=true&external"
import script from "./practice-people-authorised-trust-contact.ts?vue&type=script&lang=ts&external"
export * from "./practice-people-authorised-trust-contact.ts?vue&type=script&lang=ts&external"

import "./practice-people-authorised-trust-contact.scss?vue&type=style&index=0&id=5eee72a4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eee72a4"]])

export default __exports__